export default {"src":"/_next/static/media/bowl.49c2abcb.svg","height":20,"width":30};